import { PortalData, PortalsManagerTypes } from './types';

export const savePortal = (manager_portal: PortalData, companyId: number) => ({
  types: [
    PortalsManagerTypes.SAVE_PORTAL_REQUEST,
    PortalsManagerTypes.SAVE_PORTAL_SUCCESS,
    PortalsManagerTypes.SAVE_PORTAL_FAILURE,
  ],
  promise: (client: any) =>
    client.post('/manager_portals', { manager_portal }, { params: { companyId } }),
});

export const getPortals = (companyId: number) => ({
  types: [
    PortalsManagerTypes.GET_PORTLS_REQUEST,
    PortalsManagerTypes.GET_PORTLS_SUCCESS,
    PortalsManagerTypes.GET_PORTLS_FAILURE,
  ],
  promise: (client: any) => client.get('/manager_portals', { params: { companyId } }),
});

export const portalDelete = (id: number, companyId: number) => ({
  types: [
    PortalsManagerTypes.DELETE_PORTAL_REQUEST,
    PortalsManagerTypes.DELETE_PORTAL_SUCCESS,
    PortalsManagerTypes.DELETE_PORTAL_FAILURE,
  ],
  promise: (client: any) => client.delete(`/manager_portals/${id}`, { params: { companyId } }),
});

export const updatePortal = (id: number, manager_portal: PortalData, companyId: number) => ({
  types: [
    PortalsManagerTypes.UPDATE_PORTAL_REQUEST,
    PortalsManagerTypes.UPDATE_PORTAL_SUCCESS,
    PortalsManagerTypes.UPDATE_PORTAL_FAILURE,
  ],
  promise: (client: any) => client.patch(`/manager_portals/${id}`, { manager_portal, companyId }),
});
